import  { useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/common/Layout";
import heroImg from "../img/hero-img.jpg"; // import your local image

const SignUp = () => {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);

    const navigate = useNavigate();

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage(null);
        setError(null);
        try {
            await new Promise((r) => setTimeout(r, 900));
            setMessage("Account created! Please check your email.");
            // Set auth token
            localStorage.setItem('user_token', 'your_auth_token_here');

            // Check if there was a selected plan
            const selectedPlan = localStorage.getItem('selected_plan');
            if (selectedPlan) {
                localStorage.removeItem('selected_plan'); // Clear stored plan
                setTimeout(() => {
                    navigate('/signuppricing'); // Redirect back to pricing
                }, 1500);
            } else {
                setTimeout(() => {
                    navigate('/dashboard');
                }, 1500);
            }
        } catch (err) {
            setError("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout>
            <div className="flex flex-col md:flex-row min-h-screen bg-[#1f1b2e] text-white">
                {/* Left Side - Image */}
                <div className="relative w-full md:w-1/2 h-[40vh] md:h-auto">
                    <img
                        src={heroImg}
                        alt="Hero"
                        className="object-cover w-full h-full rounded-r-3xl"
                    />
                    {/* Back to website */}
                    <button
                        onClick={() => navigate("/")}
                        className="absolute top-6 right-6 bg-[#ffffff1a] backdrop-blur-md text-white px-4 py-2 rounded-xl text-sm font-medium hover:bg-white/30 transition"
                    >
                        Back to website →
                    </button>

                    {/* <div className="absolute bottom-10 left-10">
                        <h2 className="text-2xl font-semibold">
                            Capturing Moments,
                            <br /> Creating Memories
                        </h2>
                        <div className="flex mt-3 space-x-1">
                            <div className="w-2 h-2 rounded-full bg-white/30"></div>
                            <div className="w-2 h-2 rounded-full bg-white/30"></div>
                            <div className="w-2 h-2 rounded-full bg-white"></div>
                        </div>
                    </div> */}
                </div>

                {/* Right Side - Form */}
                <div className="flex items-center justify-center w-full md:w-1/2 px-6 md:px-16 py-10 md:py-0">
                    <form
                        onSubmit={onSubmit}
                        className="w-full max-w-md bg-[#2b2540] rounded-2xl p-8 shadow-lg"
                    >
                        <h1 className="text-3xl font-semibold mb-2">
                            Create an account
                        </h1>
                        <p className="text-sm text-gray-400 mb-6">
                            Already have an account?{" "}
                            <button
                                type="button"
                                onClick={() => navigate("/login")}
                                className="text-purple-400 hover:underline"
                            >
                                Log in
                            </button>
                        </p>

                        <div className="grid grid-cols-2 gap-3 mb-4">
                            <input
                                type="text"
                                placeholder="First name"
                                className="bg-[#3a3158] text-white px-4 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                                required
                            />
                            <input
                                type="text"
                                placeholder="Last name"
                                className="bg-[#3a3158] text-white px-4 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                            />
                        </div>

                        <input
                            type="email"
                            placeholder="Email"
                            className="w-full bg-[#3a3158] text-white px-4 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 mb-4"
                            required
                        />
                        <div className="relative mb-4">
                            <input
                                type="password"
                                placeholder="Enter your password"
                                className="w-full bg-[#3a3158] text-white px-4 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                                required
                            />
                            <span className="absolute right-4 top-3 text-gray-400 cursor-pointer">
                                👁️
                            </span>
                        </div>

                        <div className="flex items-center gap-2 mb-6">
                            <input
                                type="checkbox"
                                id="terms"
                                required
                                className="accent-purple-500 w-4 h-4"
                            />
                            <label htmlFor="terms" className="text-sm text-gray-400">
                                I agree to the{" "}
                                <a
                                    href="/terms"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-purple-400 hover:underline"
                                >
                                    Terms & Conditions
                                </a>
                            </label>
                        </div>

                        <button
                            disabled={loading}
                            className="w-full bg-purple-600 hover:bg-purple-700 py-3 rounded-lg text-white font-semibold transition disabled:opacity-60"
                        >
                            {loading ? "Creating..." : "Create account"}
                        </button>

                        {message && (
                            <p className="text-green-400 text-sm mt-3">✅ {message}</p>
                        )}
                        {error && (
                            <p className="text-red-400 text-sm mt-3">❌ {error}</p>
                        )}

                        <div className="flex items-center my-6">
                            <div className="flex-grow border-t border-gray-600"></div>
                            <span className="mx-3 text-gray-400 text-sm">
                                Or register with
                            </span>
                            <div className="flex-grow border-t border-gray-600"></div>
                        </div>

                        <div className="flex gap-3">
                            <button
                                type="button"
                                className="w-1/2 flex items-center justify-center gap-2 bg-[#3a3158] py-2.5 rounded-lg hover:bg-[#4a3f6a] transition"
                            >
                                <img
                                    src="https://cdn-icons-png.flaticon.com/512/300/300221.png"
                                    alt="Google"
                                    className="w-5 h-5"
                                />
                                Google
                            </button>
                            <button
                                type="button"
                                className="w-1/2 flex items-center justify-center gap-2 bg-[#3a3158] py-2.5 rounded-lg hover:bg-[#4a3f6a] transition"
                            >
                                <img
                                    src="https://cdn-icons-png.flaticon.com/512/179/179309.png"
                                    alt="Apple"
                                    className="w-5 h-5"
                                />
                                Apple
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Layout>
    );
};

export default SignUp;
